import React, { useState } from 'react'
import "./Shop.css"
function Shop() {
const furnitureData = [
  {
    id: 1,
    category: "sofa",
    name: "Luxury Leather Sofa",
    material: "leather",
    seaters: 3,
    size: "standard",
    color: "brown",
    onOffer: true,
    price: 750,
    image: "https://i.pinimg.com/736x/9d/46/40/9d46404a0eaf0e935b23b2a436379f4a.jpg",
    description: "Elegant handcrafted leather sofa for modern living rooms.",
    subimages:[
        "",
        "",
        "",
        "",
        "",

    ]
  },
  {
    id: 2,
    category: "sofa",
    name: "Royal Fabric Sofa",
    material: "fabric",
    seaters: 5,
    size: "large",
    color: "beige",
    onOffer: false,
    price: 1200,
    image: "https://i.pinimg.com/736x/d9/fc/5d/d9fc5d0610320b592b21e6e8e218c35a.jpg",
    description: "Comfort meets elegance with plush cushions and deep seats.",
    subimages:[
        "",
        "",
        "",
        "",
        "",

    ]
  },
  {
    id: 3,
    category: "bed",
    name: "King Size Velvet Bed",
    material: "velvet",
    seaters: "N/A",
    size: "king",
    color: "navy blue",
    onOffer: true,
    price: 1500,
    image: "https://i.pinimg.com/736x/17/88/d0/1788d0cbcb53a02b6c9f9d5d6d57b7.jpg",
    description: "Soft velvet finish with gold accents and a high headboard.",
    subimages:[
        "",
        "",
        "",
        "",
        "",

    ]
  },
  {
    id: 4,
    category: "table",
    name: "Marble Dining Table",
    material: "marble",
    seaters: 6,
    size: "medium",
    color: "white-gold",
    onOffer: false,
    price: 950,
    image: "https://i.pinimg.com/736x/6b/46/10/6b4610f87f70cc8322cf6a8f4a68df3f.jpg",
    description: "Luxury marble top with a polished golden base.",
    subimages:[
        "",
        "",
        "",
        "",
        "",

    ]
  },
  {
    id: 5,
    category: "table",
    name: "Wooden Dining Table",
    material: "wood",
    seaters: 8,
    size: "large",
    color: "oak brown",
    onOffer: true,
    price: 1150,
    image: "https://i.pinimg.com/736x/1b/f7/20/1bf7206765df03471b8c95a2433b44b4.jpg",
    description: "Classic oak table perfect for big family dinners.",
    subimages:[
        "",
        "",
        "",
        "",
        "",

    ]
  },
  {
    id: 6,
    category: "bed",
    name: "Modern Storage Bed",
    material: "wood",
    seaters: "N/A",
    size: "queen",
    color: "dark walnut",
    onOffer: false,
    price: 980,
    image: "https://i.pinimg.com/736x/0b/9a/20/0b9a20d04db58d17693b2cdbbd8230a3.jpg",
    description: "Stylish bed frame with under-bed storage drawers.",
    subimages:[
        "",
        "",
        "",
        "",
        "",

    ]
  }
];

 
 
 
 
 
 {/**
    <div class="morara-card">
      <img src="${item.image}" alt="${item.name}" class="morara-card-img" />
      <h3 class="morara-card-title">${item.name}</h3>
      <p class="morara-card-desc">${item.description}</p>

      <div class="morara-subimages">
        ${item.subImages.map(img => `<img src="${img}" alt="subimage">`).join('')}
      </div>

      <p class="morara-card-price">$${item.price}</p>
      <button class="morara-btn">Add to Cart</button>
    </div>
    */}

    const [furniture,setFurniture]=useState("All")
    const [material,setMaterial]=useState("All")
    const [size,setSize]=useState("All")

  return (
    <>
     
  <header class="morara-header">
    <h1 class="morara-title">Morara Luxury Furniture</h1>
    <p class="morara-subtitle">Fancy Beds • Elegant Sofas • Stylish Tables</p>
  </header>

  <section class="morara-filter-bar">
  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="categorySelected" onClick={()=>{setFurniture("All")}}>{furniture}</div>
    <div class="morara-dropdown-options" id="categoryOptions">
      <div data-value="all" onClick={()=>{setFurniture("All  Furniture")}} className={furniture==="All Furniture"?"furniture-active":""}>All Furniture</div>
      <div data-value="sofa" onClick={()=>{setFurniture("Sofas")}} className={furniture==="Sofas"?"furniture-active":""}>Sofas</div>
      <div data-value="bed" onClick={()=>{setFurniture("Beds")}} className={furniture==="Beds"?"furniture-active":""}>Beds</div>
      <div data-value="table" onClick={()=>{setFurniture("Tables")}} className={furniture==="Tables"?"furniture-active":""}>Tables</div>
    </div>
  </div>

  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="materialSelected">{material}</div>
    <div class="morara-dropdown-options" id="materialOptions">
      <div data-value="all" onClick={()=>{setMaterial("All Materials")}} className={material==="All Materials"?"furniture-active":""}> All Materials</div>
      <div data-value="leather" onClick={()=>{setMaterial("Leather")}} className={material==="Leather"?"furniture-active":""}>Leather</div>
      <div data-value="fabric" onClick={()=>{setMaterial("Fabric")}} className={material==="Fabric"?"furniture-active":""}>Fabric</div>
      <div data-value="velvet" onClick={()=>{setMaterial("Velvet")}} className={material==="Velvet"?"furniture-active":""}>Velvet</div>
      <div data-value="wood" onClick={()=>{setMaterial("Wood")}} className={material==="Wood"?"furniture-active":""}>Wood</div>
      <div data-value="marble" onClick={()=>{setMaterial("Marble")}} className={material==="Marble"?"furniture-active":""}>Marble</div>
    </div>
  </div>

  <div class="morara-dropdown">
    <div class="morara-dropdown-selected" id="seaterSelected">{size}</div>
    <div class="morara-dropdown-options" id="seaterOptions">
      <div data-value="all" onClick={()=>{setSize("All Sizes")}} className={material==="All Sizes"?"furniture-active":""}>All Sizes</div>
      <div data-value="3" onClick={()=>{setSize("3seater")}} className={material==="3seater"?"furniture-active":""}>3 Seater</div>
      <div data-value="5" onClick={()=>{setSize("5seater")}} className={material==="5seater"?"furniture-active":""}>5 Seater</div>
      <div data-value="queen" onClick={()=>{setSize("Queen")}} className={material==="Queen"?"furniture-active":""}>Queen Size</div>
      <div data-value="king" onClick={()=>{setSize("King")}} className={material==="King"?"furniture-active":""}>King Size</div>
    </div>
  </div>
</section>

  <main id="moraraProducts" class="morara-products">
{furnitureData.map((item)=>(
   <div class="morara-card">
  <img
    src="https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    alt="Luxury Leather Sofa"
    class="morara-card-img"
  />

  <h3 class="morara-card-title">Luxury Leather Sofa</h3>
  <p class="morara-card-desc">
    A stylish 5-seater sofa crafted from premium leather for a modern living room setup.
  </p>

  <div class="morara-subimages">
    <img src="https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="subimage 1" />
    <img src="https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="subimage 1" />
    <img src="https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="subimage 1" />
    <img src="https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="subimage 1" />
    <img src="https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="subimage 1" />
  </div>
<div className='morara-actions'>
  <p class="morara-card-price">Ksh 60,000</p>
  <button class="morara-btn">View</button>
  </div>
</div> 
))}
    

</main>
 


    </>
  )
}

export default Shop
